<template>
  <div>
    <Menu/>

    <div class="container-fluid pt-5" v-if="loading">
      <h1>Loading</h1>
    </div>

    <div v-else>
      <!-- banners -->
      <section v-if="$store.state.searchState == 'Residential'">
        <div class="container-fluid g-0 pt-3">
          <div class="row g-0">
            <div class="col text-center">
              <div class="portfolio-banner">
                <div class="row">
                  <div class="col-lg-6 mx-auto align-self-center switch-white pb-5">
                    <h1 class="display-2 pb-5">Residential</h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section v-if="$store.state.searchState == 'Commercial'">
        <div class="container-fluid g-0 pt-3">
          <div class="row g-0">
            <div class="col text-center">
              <div class="commercial-banner">
                <div class="row">
                  <div class="col-lg-6 mx-auto align-self-center switch-white pb-5">
                    <h1 class="display-2 pb-5">Commercial</h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section v-if="$store.state.searchState == 'Farms'">
        <div class="container-fluid g-0 pt-3">
          <div class="row g-0">
            <div class="col text-center">
              <div class="farms-banner">
                <div class="row">
                  <div class="col-lg-6 mx-auto align-self-center switch-white pb-5">
                    <h1 class="display-2 pb-5">Farms & Small Holdings</h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- residential search -->
      <section v-if="$store.state.searchState == 'Residential' && !loading">
        <div class="container text-center">
          <div class="row mt-5 mb-5 justify-content-center">
            <div class="col-md-3" v-if="$store.state.filterProperty != 'Vacant Land'">
              <button
                class="btn btn-primary filter-btn filterOne"
                :class="{ 'active': $store.state.filterType == 'For Sale' }"
                v-on:click="$store.state.filterType = 'For Sale';">
                Buy
              </button>
              <button
                class="btn btn-primary filter-btn filterOne"
                :class="{ 'active': $store.state.filterType == 'To Let' }"
                v-on:click="$store.state.filterType = 'To Let';">
                Rent
              </button>
            </div>

            <div class="col-md-3">
              <button
                class="btn btn-primary filter-btn filterOne"
                :class="{ 'active': $store.state.filterProperty == 'House' }"
                v-on:click="$store.state.filterProperty = 'House'; $store.state.filterType = 'For Sale';">
                House
              </button>
              <button
                class="btn btn-primary filter-btn filterOne"
                :class="{ 'active': $store.state.filterProperty == 'Lodge' }"
                v-on:click="$store.state.filterProperty = 'Lodge'; $store.state.filterType = 'For Sale';">
                Lodge
              </button>
              <button
                class="btn btn-primary filter-btn filterOne"
                :class="{ 'active': $store.state.filterProperty == 'Apartment' }"
                v-on:click="$store.state.filterProperty = 'Apartment'; $store.state.filterType = 'For Sale';">
                Apartment
              </button>
              <button
                class="btn btn-primary filter-btn filterOne"
                :class="{ 'active': $store.state.filterProperty == 'Vacant Land' }"
                :disabled="$store.state.filterProperty == 'Vacant Land'"
                v-on:click="$store.state.filterProperty = 'Vacant Land'; $store.state.filterType = 'For Sale';">
                Plot
              </button>
            </div>

            <div class="col-md-3" v-if="$store.state.filterProperty != 'Vacant Land'">
              <div class="container-fluid">
                <div class="row" v-if="$store.state.filterType != 'To Let'">
                  <div class="col-12">
                    <p class="text-start mb-1">Max Price - R {{ maxPrice / 1000000 }} million
                      <input type="range" class="form-range" v-model="maxPrice" :min="2000000" :max="250000000" :step="1000000" />
                    </p>
                  </div>
                </div>
                <div class="row pt-3">
                  <div class="col-6">
                    <p class="text-start"><small>Beds - {{ beds }}</small></p>
                    <input type="range" class="form-range" v-model="beds" min="1" max="20" step="1" />
                  </div>
                  <div class="col-6">
                    <p class="text-start"><small>Baths - {{ baths }}</small></p>
                    <input type="range" class="form-range" v-model="baths" min="1" max="20" step="1" />
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-3 ps-5 pt-1">
              <input type="text" class="form-control mb-3 w-100" placeholder="Enter your web reference" v-model="web_ref_search" />
              <input type="text" class="form-control mb-3 w-100" placeholder="Enter a location here" v-model="$store.state.search.text" />
              <ul v-if="locationSuggestions.length > 0 && $store.state.search.text != ''" class="list-group">
                <li v-for="suggestion in locationSuggestions" :key="suggestion" class="list-group-item">
                  <div v-on:click="$store.state.search.text = suggestion" style="cursor: pointer;">{{ suggestion }}</div>
                </li>
              </ul>
            </div>
          </div>

          <div class="row">
            <div class="col-12 mb-4">
              <button class="btn btn-primary filter-btn" :class="{ 'active': highToLow }" v-on:click="highToLow = true" style="font-size: 10px;">price high to low</button>
              <button class="btn btn-primary filter-btn" :class="{ 'active': !highToLow }" v-on:click="highToLow = false" style="font-size: 10px;">price low to high</button>
            </div>
          </div>

          <div class="row" v-if="!loading">
            <div
              class="col-md-6 mb-4"
              v-for="fItem in filteredListings"
              :key="fItem[0].id"
              v-if="fItem[0].listing_type == $store.state.filterType && (fItem[0].property_type == $store.state.filterProperty || ($store.state.filterProperty == 'House' && fItem[0].property_type == 'Townhouse')) && fItem[0].status != 'Archived' && fItem[0].status != 'Pending'">
              <div class="banner-section wineland-property p-4 h-100 bg-light">
                <div class="row">
                  <div class="col-md-5">
                    <div class="portfolio-thumbnail">
                      <a :href="'/property/' + fItem[0].id"><img :src="fItem[0].listing_images[0]" class="w-100 force-height"></a>
                    </div>
                  </div>
                  <div class="col-md-7 text-start">
                    <span class="tag">{{ fItem[0].listing_type }}</span>
                    <span class="tag">{{ fItem[0].property_type }}</span>
                    <span class="tag">{{ fItem[0].status }}</span>
                    <p class="mt-4">
                      <strong>{{ formatCurrency(parseInt(fItem[0].price)) }} {{ fItem[0].listing_type }}
                        <span v-if="fItem[0].listing_type === 'To Let'">
                          {{ fItem[0].price_term }}
                        </span>
                      </strong>
                    </p>
                    <p class="text-uppercase"><strong>{{ cleanHeading(fItem[0].marketing_heading) }}</strong></p>
                    <p>{{ fItem[0].loc_suburb }}, {{ fItem[0].loc_region }}</p>
                    <p class="mt-4"><a class="btn btn-cta filter-btn" :href="'/property/' + fItem[0].id">VIEW <i class="bi bi-arrow-right"></i></a></p>
                    <p style="font-size: 12px; font-weight: bold;">Web Reference: {{ fItem[0].web_ref }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- commercial search -->
      <section v-if="$store.state.searchState == 'Commercial' && !loading">
        <div class="container text-center">
          <div class="row mt-5 mb-5 justify-content-center">
            <div class="col-md-3">
              <button
                class="btn btn-primary filter-btn filterOne"
                :class="{ 'active': $store.state.filterType == 'For Sale' }"
                v-on:click="$store.state.filterType = 'For Sale'; $store.state.searchState = 'Commercial'">
                Buy
              </button>
              <button
                class="btn btn-primary filter-btn filterOne"
                :class="{ 'active': $store.state.filterType == 'To Let' }"
                v-on:click="$store.state.filterType = 'To Let'; $store.state.searchState = 'Commercial'">
                Rent
              </button>
            </div>

            <div class="col-md-3 ps-5 pt-1">
              <input type="text" class="form-control mb-3 w-100" placeholder="Enter your web reference" v-model="web_ref_search" />
              <input type="text" class="form-control mb-3 w-100" placeholder="Enter a location here" v-model="$store.state.search.text" />
              <ul v-if="locationSuggestionsCommercial.length > 0 && $store.state.search.text != ''" class="list-group">
                <li v-for="suggestion in locationSuggestionsCommercial" :key="suggestion" class="list-group-item">
                  <div v-on:click="$store.state.search.text = suggestion" style="cursor: pointer;">{{ suggestion }}</div>
                </li>
              </ul>
            </div>
          </div>

          <div class="row">
            <div class="col-12 mb-4">
              <button class="btn btn-primary filter-btn" :class="{ 'active': highToLow }" v-on:click="highToLow = true" style="font-size: 10px;">price high to low</button>
              <button class="btn btn-primary filter-btn" :class="{ 'active': !highToLow }" v-on:click="highToLow = false" style="font-size: 10px;">price low to high</button>
            </div>
          </div>

          <div class="row" v-if="!loading">
            <div
              class="col-md-6 mb-4"
              v-for="fItem in filteredListingsCommercial"
              :key="fItem[0].id"
              v-if="fItem[0].listing_type == $store.state.filterType && !isFarmProperty(fItem[0].property_type) && fItem[0].status != 'Archived' && fItem[0].status != 'Pending'">
              <div class="banner-section wineland-property p-4 h-100 bg-light">
                <div class="row">
                  <div class="col-md-5">
                    <div class="portfolio-thumbnail">
                      <a :href="'/commercial/' + fItem[0].id"><img :src="fItem[0].listing_images[0]" class="w-100 force-height"></a>
                    </div>
                  </div>
                  <div class="col-md-7 text-start">
                    <span class="tag">{{ fItem[0].listing_type }}</span>
                    <span class="tag">{{ fItem[0].property_type }}</span>
                    <span class="tag">{{ fItem[0].status }}</span>
                    <p class="mt-4">
                      <strong v-if="isPOA(fItem[0])">POA</strong>
                      <strong v-else>{{ formatCurrency(parseInt(fItem[0].price)) }} {{ fItem[0].listing_type }}
                        <span v-if="fItem[0].listing_type === 'To Let'">
                          {{ fItem[0].price_term }}
                        </span>
                      </strong>
                    </p>
                    <p class="text-uppercase"><strong>{{ cleanHeading(fItem[0].marketing_heading) }}</strong></p>
                    <p>{{ fItem[0].loc_suburb }}, {{ fItem[0].loc_region }}</p>
                    <p class="mt-4"><a class="btn btn-cta filter-btn" :href="'/commercial/' + fItem[0].id">VIEW <i class="bi bi-arrow-right"></i></a></p>
                    <p style="font-size: 12px; font-weight: bold;">Web Reference: {{ fItem[0].web_ref }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- farms search -->
      <section v-if="$store.state.searchState == 'Farms' && !loading">
        <div class="container text-center">
          <div class="row mt-5 mb-5 justify-content-center">
            <div class="col-md-3 text-center">
              <p class="text-start">Maximum Price - R {{ maxPrice / 1000000 }} million
                <input type="range" class="form-range" v-model="maxPrice" :min="2000000" :max="250000000" :step="1000000" />
              </p>
            </div>

            <div class="col-md-3 ps-5 pt-1">
              <input type="text" class="form-control mb-3 w-100" placeholder="Enter your web reference" v-model="web_ref_search" />
              <input type="text" class="form-control mb-3 w-100" placeholder="Enter a location here" v-model="$store.state.search.text" />
              <ul v-if="locationSuggestionsCommercial.length > 0 && $store.state.search.text != ''" class="list-group">
                <li v-for="suggestion in locationSuggestionsCommercial" :key="suggestion" class="list-group-item">
                  <div v-on:click="$store.state.search.text = suggestion" style="cursor: pointer;">{{ suggestion }}</div>
                </li>
              </ul>
            </div>
          </div>

          <div class="row">
            <div class="col-12 mb-4">
              <button class="btn btn-primary filter-btn" :class="{ 'active': highToLow }" v-on:click="highToLow = true" style="font-size: 10px;">price high to low</button>
              <button class="btn btn-primary filter-btn" :class="{ 'active': !highToLow }" v-on:click="highToLow = false" style="font-size: 10px;">price low to high</button>
            </div>
          </div>

          <div class="row" v-if="!loading">
            <div
              class="col-md-6 mb-4"
              v-for="fItem in filteredListingsCommercial"
              :key="fItem[0].id"
              v-if="fItem[0].listing_type == $store.state.filterType && isFarmProperty(fItem[0].property_type) && fItem[0].status != 'Archived' && fItem[0].status != 'Pending'">
              <div class="banner-section wineland-property p-4 h-100 bg-light">
                <div class="row">
                  <div class="col-md-5">
                    <div class="portfolio-thumbnail">
                      <a :href="'/commercial/' + fItem[0].id"><img :src="fItem[0].listing_images[0]" class="w-100 force-height"></a>
                    </div>
                  </div>
                  <div class="col-md-7 text-start">
                    <span class="tag">{{ fItem[0].listing_type }}</span>
                    <span class="tag">{{ fItem[0].property_type }}</span>
                    <span class="tag">{{ fItem[0].status }}</span>
                    <p class="mt-4">
                      <strong v-if="isPOA(fItem[0])">POA</strong>
                      <strong v-else>{{ formatCurrency(parseInt(fItem[0].price)) }}</strong>
                    </p>
                    <p class="text-uppercase"><strong>{{ cleanHeading(fItem[0].marketing_heading) }}</strong></p>
                    <p>{{ fItem[0].loc_suburb }}, {{ fItem[0].loc_region }}</p>
                    <p class="mt-4"><a class="btn btn-cta filter-btn" :href="'/commercial/' + fItem[0].id">VIEW <i class="bi bi-arrow-right"></i></a></p>
                    <p style="font-size: 12px; font-weight: bold;">Web Reference: {{ fItem[0].web_ref }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <Footer/>
  </div>
</template>

<script>
import axios from 'axios'
import Menu from '@/components/Menu.vue'
import Footer from '@/components/Footer.vue'

export default {
  components: {
    Menu, Footer
  },
  data() {
    return {
      fusionListings: [],
      fusionListingsCommercial: [],
      loading: true,
      selectedType: null,
      selectedLocations: [],
      minPrice: 0,
      maxPrice: 250000000,
      currentPage: 1,
      itemsPerPage: 8,
      highToLow: true,
      beds: 20,
      baths: 20,
      web_ref_search: ''
    }
  },
  mounted() {
    this.fetchListings()
    this.fetchListingsCommercial()
  },
  computed: {
    totalPages() {
      return Math.ceil(this.filteredListings.length / this.itemsPerPage)
    },
    paginatedListingsFiltered() {
      const startIndex = (this.currentPage - 1) * this.itemsPerPage
      const endIndex = startIndex + this.itemsPerPage
      return this.filteredListings.slice(startIndex, endIndex)
    },
    filteredListings() {
      let filteredListings = this.fusionListings.filter(listing => {
        if (!listing || !listing[0]) return false

        const item = listing[0]
        let locationSearchFilter = true
        if (this.$store.state.search.text) {
          locationSearchFilter = `${item.loc_suburb || ''}, ${item.loc_region || ''}, ${item.marketing_heading || ''}`
            .toLowerCase()
            .includes(this.$store.state.search.text.toLowerCase())
        }

        let webRefFilter = true
        if (this.web_ref_search) {
          let webRefValue = ''
          if (item.web_ref !== null && item.web_ref !== undefined) {
            webRefValue = item.web_ref.toString().toLowerCase()
          }
          webRefFilter = webRefValue.includes(this.web_ref_search.toLowerCase())
        }

        const minPriceFilter = parseInt(item.price) >= this.minPrice
        const maxPriceFilter = parseInt(item.price) <= this.maxPrice
        const maxBaths = parseInt(item.bathrooms) <= this.baths
        const maxBeds = parseInt(item.bedrooms) <= this.beds
        const hasFeaturedImage = item.listing_images && item.listing_images.length > 0

        return locationSearchFilter && webRefFilter && minPriceFilter && maxPriceFilter && maxBaths && maxBeds && hasFeaturedImage
      })

      if (this.highToLow) {
        filteredListings.sort((a, b) => parseInt(b[0].price) - parseInt(a[0].price))
      } else {
        filteredListings.sort((a, b) => parseInt(a[0].price) - parseInt(b[0].price))
      }

      return filteredListings
    },
    locationSuggestions() {
      if (!Array.isArray(this.fusionListings)) return []

      const uniqueLocations = Array.from(new Set(
        this.fusionListings.map((item) => {
          const loc = item && item[0]
          if (!loc || !loc.loc_suburb || !loc.loc_region) return null
          return `${loc.loc_suburb}, ${loc.loc_region}`
        }).filter(Boolean)
      ))

      return uniqueLocations.filter(location =>
        location.toLowerCase().includes(this.$store.state.search.text.toLowerCase())
      )
    },
    filteredListingsCommercial() {
      let filteredListings = this.fusionListingsCommercial.filter(listing => {
        if (!listing || !listing[0]) return false

        const item = listing[0]
        let locationSearchFilter = true
        if (this.$store.state.search.text) {
          locationSearchFilter = `${item.loc_suburb || ''}, ${item.loc_region || ''}, ${item.marketing_heading || ''}`
            .toLowerCase()
            .includes(this.$store.state.search.text.toLowerCase())
        }

        let webRefFilterCommercial = true
        if (this.web_ref_search) {
          let webRefValue = ''
          if (item.web_ref !== null && item.web_ref !== undefined) {
            webRefValue = item.web_ref.toString().toLowerCase()
          }
          webRefFilterCommercial = webRefValue.includes(this.web_ref_search.toLowerCase())
        }

        const isPOA = this.isPOA(item)
        const minPriceFilter = isPOA || parseInt(item.price) >= this.minPrice
        const maxPriceFilter = isPOA || parseInt(item.price) <= this.maxPrice
        const hasFeaturedImage = item.listing_images && item.listing_images.length > 0

        return locationSearchFilter && webRefFilterCommercial && minPriceFilter && maxPriceFilter && hasFeaturedImage
      })

      if (this.highToLow) {
        filteredListings.sort((a, b) => parseInt(b[0].price) - parseInt(a[0].price))
      } else {
        filteredListings.sort((a, b) => parseInt(a[0].price) - parseInt(b[0].price))
      }

      return filteredListings
    },
    locationSuggestionsCommercial() {
      if (!Array.isArray(this.fusionListingsCommercial)) return []

      const uniqueLocations = Array.from(new Set(
        this.fusionListingsCommercial.map((item) => {
          const loc = item && item[0]
          if (!loc || !loc.loc_suburb || !loc.loc_region) return null
          return `${loc.loc_suburb}, ${loc.loc_region}`
        }).filter(Boolean)
      ))

      return uniqueLocations.filter(location =>
        location.toLowerCase().includes(this.$store.state.search.text.toLowerCase())
      )
    }
  },
  methods: {
    cleanHeading(h) {
      return (h || '')
        .replace(/ΓÇô/g, '–')
        .replace(/ΓÇÖ/g, '’')
        .replace(/â€™/g, '’')
        .replace(/â€œ/g, '“')
        .replace(/â€/g, '”')
        .replace(/â€/g, '…')
        .replaceAll('<br/>', '')
    },
    isFarmProperty(propertyType) {
      const normalized = (propertyType || '').trim().toLowerCase()
      return ['farm', 'small holding', 'smallholding'].includes(normalized)
    },
    isPOA(item) {
      return item && (item.poa === true || item.poa === 'true' || parseInt(item.price) === 999999999)
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage -= 1
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage += 1
      }
    },
    selectLocationSuggestion(suggestion) {
      this.$store.state.search.text = suggestion
      this.selectedLocations.push(suggestion)
    },
    async fetchListings() {
      this.loading = true
      try {
        const response = await axios.get('https://luxurywinelandsestates.co.za/api/fusion-listings-v2.php', {
          headers: {
            'Accept': 'application/json'
          }
        })
        this.fusionListings = response.data
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async fetchListingsCommercial() {
      this.loading = true
      try {
        const response = await axios.get('https://luxurywinelandsestates.co.za/api/fusion-listings-commercial-v2.php', {
          headers: {
            'Accept': 'application/json'
          }
        })
        this.fusionListingsCommercial = response.data
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.force-height {
  height: 300px;
  object-fit: cover;
}
.social-links{
  position: unset;
  display: inline;
  float: right;
  margin-right: 20px;
}
.filterTwo {
  font-size: 9px;
  padding: 10px;
}
.tag {
  background-color: #255699;
  color: #fff;
  font-size: 12px;
  font-weight: bold;
  padding: 5px;
  border-radius: 30px;
  padding-left: 20px;
  padding-right: 20px;
}
</style>
